// extracted by mini-css-extract-plugin
export default {"fw":"SidebarMenu_fw__BdvCQ","sidebar":"SidebarMenu_sidebar__KUbQ4"};